var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
export const resolveSchemaWithRef = (schema, definitions) => {
    var _a;
    if ((schema === null || schema === void 0 ? void 0 : schema.$ref) === undefined || typeof schema.$ref !== 'string') {
        return schema;
    }
    const { $ref } = schema, partialWithoutRef = __rest(schema, ["$ref"]);
    const refPath = $ref.replace('#/definitions/', '');
    const refDefinition = (_a = definitions[refPath]) !== null && _a !== void 0 ? _a : {};
    return Object.assign(Object.assign({}, partialWithoutRef), refDefinition);
};
//# sourceMappingURL=resolve-schema-with-ref.js.map